/**
 * TanStack Query hooks for `indoleads-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	indoleadsIntegrationQueryKeys,
	type CreateIndoleadsIntegrationBody,
	type ListIndoleadsIntegrationResponse,
	type IndoleadsIntegrationRow,
} from "./api";

export function useIndoleadsIntegrationList(): UseQueryResult<ListIndoleadsIntegrationResponse, Error> {
	return useQuery({
		queryKey: indoleadsIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useIndoleadsIntegrationCreate(): UseMutationResult<IndoleadsIntegrationRow, Error, CreateIndoleadsIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: indoleadsIntegrationQueryKeys.all });
		},
	});
}

export function useIndoleadsIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: indoleadsIntegrationQueryKeys.all });
		},
	});
}
